import { createFileRoute } from '@tanstack/react-router';
import { HelpDeskUnlogged } from '@/features/support/HelpDeskUnlogged';

export const Route = createFileRoute('/_public/help-desk-unlog')({ component: HelpDeskUnlogged });
